__turbopack_context__.v({
  "fixedNavContainer": "G9OoAq_fixedNavContainer",
  "fixedNavblock": "G9OoAq_fixedNavblock",
  "fixedNavigationHidden": "G9OoAq_fixedNavigationHidden",
  "fixedNavigationShown": "G9OoAq_fixedNavigationShown",
  "navblock": "G9OoAq_navblock",
  "navblockContainer": "G9OoAq_navblockContainer",
});
